module.exports = __webpack_public_path__ + "static/media/Logo.aaf7cc02.png";